import { Users } from "lucide-react";

export default function LeadershipPage() {
  return (
    <div data-testid="leadership-page">
      <section className="bg-[#1C2E4A] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#C8A97E] font-semibold mb-3">Our Leaders</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
            Church Leadership
          </h1>
        </div>
      </section>
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div data-testid="leader-shannon" className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-8 text-center">
              <div className="w-20 h-20 rounded-full bg-[#1C2E4A]/10 flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-[#1C2E4A]" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-[#1C2E4A] mb-1">Shannon Baker</h3>
              <p className="text-sm text-[#C8A97E] font-medium mb-4">Co-Founder & Director</p>
              <p className="text-sm text-[#595959] leading-relaxed">
                Shannon has dedicated over 20 years to home education and church school ministry. Her passion for supporting families through faith-based education drives everything ACS Virtual Church does.
              </p>
            </div>
            <div data-testid="leader-eric" className="bg-[#FAF9F6] rounded-xl border border-[#E5E2DC] p-8 text-center">
              <div className="w-20 h-20 rounded-full bg-[#1C2E4A]/10 flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-[#1C2E4A]" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-[#1C2E4A] mb-1">Eric Baker</h3>
              <p className="text-sm text-[#C8A97E] font-medium mb-4">Co-Founder & Operations</p>
              <p className="text-sm text-[#595959] leading-relaxed">
                Eric oversees the operational and technical side of ACS Virtual Church, ensuring families and churches have the systems and support they need to succeed.
              </p>
            </div>
          </div>
          <div className="mt-14 text-center">
            <p className="text-sm text-[#595959] leading-relaxed max-w-2xl mx-auto">
              Together, Shannon and Eric founded ACS Virtual Church and Alabama Church School to serve homeschool families and churches across Alabama. Their combined experience in education, ministry, and technology allows them to provide a unique, faith-based approach to church school administration.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
